export default __webpack_public_path__ + "static/media/Reports.6cb6e060.svg";